<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'App',
  methods: {
    async getCatalog() {
      const response = await axios.get('/api/Alibaba_Category/getAllCategoryData')

      let catalog = [],
        tempChildren = [];
      response.data.rows.forEach(i => {
        tempChildren = [];
        i.Nodes.forEach(item => tempChildren.push({
          title: item.CategoryName,
          id: item.Category_Id
        }))

        catalog.push({
          title: i.CategoryName,
          icon: i.Icon,
          id: i.Category_Id,
          children: tempChildren,
        })
      })

      this.$store.commit('setCatalog', catalog);
      this.$store.commit('setDefaultCatalogId', catalog[0].children[0].id)
      this.$store.commit('setCatalogName', `${catalog[0].title}|${catalog[0].children[0].title}`)
    }
  },
  beforeCreate() {
    if (screen.width >= 1000) {
      const url = 'https://' + location.host.replace('m.', 'www.')
      window.location.replace(url)
    }
  },
  mounted() {
    this.getCatalog();
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>